
import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import AboutPage from '../pages/about/page';
import ServicePage from '../pages/service/page';
import MembersPage from '../pages/members/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/service',
    element: <ServicePage />,
  },
  {
    path: '/members',
    element: <MembersPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
